// Mock data for Z&N Solar website

export const mockProducts = [
  {
    id: 1,
    name: "Batterie Lithium PowMr 200Ah 51,2V 10kW",
    category: "battery",
    image: "/api/uploads/batterie-200ah-512v-nouvelle.png",
    specs: ["Tension: 51,2V", "Capacité: 200Ah", "Puissance: 10kW", "Écran LCD intégré", "BMS intelligent", "Garantie: 10 ans"],
    description: "Batterie lithium haute puissance PowMr 51,2V 200Ah avec système BMS intelligent et écran de contrôle intégré",
    price: "À partir de 3500€"
  },
  {
    id: 2,
    name: "Batterie Lithium PowMr 200Ah 51,2V 10kW - Série Pro",
    category: "battery",
    image: "/api/uploads/batterie-200ah-512v-nouvelle.png",
    specs: ["Tension: 51,2V", "Capacité: 200Ah", "Puissance: 10kW", "Communication RS485", "Parallélisation possible", "Garantie: 10 ans"],
    description: "Batterie lithium professionnelle PowMr avec communication RS485 pour installation en parallèle",
    price: "À partir de 3800€"
  },
  {
    id: 3,
    name: "Kit Batterie PowMr 200Ah + Convertisseur 5kW",
    category: "kit",
    image: "/api/uploads/batterie-200ah-512v-nouvelle.png",
    specs: ["Batterie: 51,2V 200Ah", "Convertisseur: 5000W", "Installation complète", "Monitoring inclus", "Garantie: 10 ans"],
    description: "Kit complet batterie PowMr 200Ah avec convertisseur hybride 5kW pour installation résidentielle",
    price: "À partir de 5200€"
  },
  {
    id: 4,
    name: "Solution Stockage PowMr 10kW Modulaire",
    category: "kit",
    image: "/api/uploads/batterie-200ah-512v-nouvelle.png",
    specs: ["Puissance: 10kW", "Modulable jusqu'à 40kW", "Communication intelligente", "Installation plug&play", "Garantie: 15 ans"],
    description: "Solution de stockage modulaire PowMr pour installations commerciales et industrielles",
    price: "Sur devis"
  },
  {
    id: 5,
    name: "Batterie PowMr 200Ah Pack Résidentiel",
    category: "battery",
    image: "/api/uploads/batterie-200ah-512v-nouvelle.png",
    specs: ["Tension: 51,2V", "Capacité: 200Ah", "Compact résidentiel", "Installation murale", "App mobile incluse", "Garantie: 10 ans"],
    description: "Batterie lithium PowMr optimisée pour installation résidentielle avec application mobile de monitoring",
    price: "À partir de 3200€"
  },
  {
    id: 6,
    name: "Batterie PowMr 200Ah Haute Performance",
    category: "battery",
    image: "/api/uploads/batterie-200ah-512v-nouvelle.png",
    specs: ["Tension: 51,2V", "Capacité: 200Ah", "Cycles: 6000+", "Refroidissement passif", "Certification CE", "Garantie: 12 ans"],
    description: "Batterie lithium haute performance PowMr avec plus de 6000 cycles de vie et refroidissement optimisé",
    price: "À partir de 4100€"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Ahmed Traoré",
    location: "Bamako, Mali",
    text: "Installation parfaite de mon système solaire. L'équipe Z&N Solar est très professionnelle et le support technique excellent.",
    rating: 5,
    avatar: "/assets/avatars/avatar-1.jpg"
  },
  {
    id: 2,
    name: "Marie Dubois",
    location: "Seine-et-Marne, France",
    text: "Batteries de très haute qualité. Aucun problème depuis 2 ans d'utilisation. Service client réactif.",
    rating: 5,
    avatar: "/assets/avatars/avatar-2.jpg"
  },
  {
    id: 3,
    name: "Mamadou Keita",
    location: "Sikasso, Mali",
    text: "Le convertisseur hybride fonctionne parfaitement. Installation rapide et équipe compétente.",
    rating: 5,
    avatar: "/assets/avatars/avatar-3.jpg"
  }
];

export const mockQuoteRequests = [
  {
    id: 1,
    name: "Jean Martin",
    email: "jean.martin@email.com",
    phone: "+33123456789",
    project: "Installation solaire résidentielle",
    message: "Besoin d'un devis pour une maison de 150m²",
    status: "pending",
    date: "2024-01-15"
  }
];

export const companyInfo = {
  name: "Z&N Solar",
  slogan: "L'excellence sans compromis",
  description: "Spécialiste en batteries lithium et convertisseurs hybrides, nous proposons des solutions énergétiques de haute qualité conformes aux normes européennes.",
  addresses: [
    {
      type: "Siège social",
      address: "Moisenay, Région Parisienne, France",
      country: "France"
    },
    {
      type: "Bureau commercial",
      address: "Bamako, Mali",
      country: "Mali"
    }
  ],
  contact: {
    emails: ["contact@znsolar.fr", "seydoumalle@znsolar.fr"],
    phone: "06 23 73 77 80",
    whatsapp: "06 23 73 77 80"
  },
  services: [
    "Support technique expert",
    "Garantie pièces et main d'œuvre",
    "Remplacement sous conditions",
    "Installation professionnelle",
    "Maintenance préventive"
  ],
  certifications: [
    "Conformité CE",
    "Normes européennes",
    "ISO 9001",
    "Garantie 10 ans"
  ]
};